import ChartSection from './ChartSection';
import CreditInfoSection from './CreditInfoSection';
import MatrixSection from './MatrixSection';
import PreviousPriceSection from './PreviousPriceSection';
import './SummaryTabComponent.scss';
import ValuationSection from './ValuationSection';

const SummaryTabComponent = () => {
  return (
    <div className="summary-tab" data-testid="tab-content-summary">
      <div className="summary-tab-top-row">
        <div className="summary-tab-chart">
          <ChartSection />
        </div>
        <div className="summary-tab-right-column">
          <MatrixSection />
          <ValuationSection />
        </div>
      </div>
      <div className="summary-tab-bottom-sections">
        <div className="summary-tab-previous-price">
          <PreviousPriceSection />
        </div>
        <div className="summary-tab-credit-info">
          <CreditInfoSection />
        </div>
      </div>
    </div>
  );
};

export default SummaryTabComponent;
